<script>
  import { onMount } from "svelte";
  import { formatDate, toast, dateInitializer } from "../../../helpers/utils.svelte";
  import { translator } from "../../../store";
  import DatePicker from "../../../components/Form/DatePicker.svelte";
  import {
    Button,
    Modal,
    TextInput,
    Textarea,
    Select,
    Autocomplete,
    FileUpload,
  } from "../../../components/index.svelte";
  import {
    createMaintenance,
    getProperties,
    updateMaintenance,
    getMaintenanceDetails
  } from "../../../helpers/apiHelpers/index.svelte";

  export let propertyID;
  export let onModalClose;
  export let showPropertySelection = false;
  export let modalType = 'edit';

  export async function modalToggleWrapper(propertyID, maintenanceID) {
    toggler();
    if (propertyID && maintenanceID) {
      maintenanceDetails = await getMaintenanceDetails(propertyID, maintenanceID);
    } else {
      maintenanceDetails = null;
    }
  }

  let maintenanceDetails;
  let propertyList = null;
  let toggler;
  let maintenanceTypeOptions = [
    { text: translator("CLEANING"), value: "CLEANING" },
    { text: translator("REPAIRING"), value: "REPAIRING" },
    { text: translator("FIXTURE"), value: "FIXTURE" },
    { text: translator("GROCERY"), value: "GROCERY" },
    { text: translator("LOAN"), value: "LOAN" },
    { text: translator("BILL"), value: "BILL" },
  ];
  let modalTitle = translator("Bakım/Onarım Kaydı Oluştur");
  if (maintenanceDetails?.id) {
    modalTitle = translator("Bakım/Onarım Bilgilerini Düzenle");
  }

  async function onMaintenanceFormSubmit(e) {
    try {
      const formData = new FormData(e.target);
      const typeText = maintenanceTypeOptions.find(
        (i1) => i1.value == formData.get("type")
      ).text;
      let propertyToMaintain = propertyID;
      if (!propertyToMaintain && showPropertySelection) {
        propertyToMaintain = formData.get("property_id");
      }
      if (maintenanceDetails?.id) {
        await updateMaintenance(
          propertyToMaintain,
          maintenanceDetails?.id,
          new FormData(e.target)
        );
      } else {
        await createMaintenance(propertyToMaintain, new FormData(e.target));
      }
      toast.success(
        translator("Başarılı"),
        translator('"__MAINTENANCETYPE__" kaydı oluşturuldu', {
          __MAINTENANCETYPE__: typeText,
        })
      );
      modalToggleWrapper();
    } catch (err) {
      toast.error(
        translator("Hata"),
        translator(
          err.getResponseMessage ? err.getResponseMessage() : err.message
        )
      );
    }
  }
  function getCurrentDay() {
    return formatDate(dateInitializer(), "Y-m-d");
  }

  onMount(async () => {
    if (showPropertySelection) {
      propertyList = await getProperties(true);
    }
  });
</script>

<Modal
  bind:toggle={toggler}
  title={modalTitle}
  onClose={onModalClose}
>
  <div slot="modal-body">
    <form
      class="basic-form"
      id="maintenance-form"
      on:submit|preventDefault={onMaintenanceFormSubmit}
    >
      <div class="row">
        {#if propertyList}
          <div class="col-md-12 p-2">
            <Autocomplete
              label={translator("Ev")}
              labelField="name"
              valueField="id"
              fieldName="property_id"
              placeholder={translator("Ev seçiniz")}
              options={propertyList}
              value={maintenanceDetails?.property_id}
            />
          </div>
        {/if}
        <div class="col-md-6 col-sm-12 p-2">
          <TextInput
            type="text"
            fieldName="employee"
            label={translator("Görevli Kişi")}
            value={maintenanceDetails?.employee}
          />
        </div>
        <div class="col-md-6 col-sm-12 p-2">
          <Select
            fieldName="type"
            label={translator("Masraf Tipi")}
            selectOptions={maintenanceTypeOptions}
            required
            value={maintenanceDetails?.type}
          />
        </div>
        <div class="col-md-12 p-2">
          <Textarea
            fieldName="description"
            label={translator("Açıklama")}
            required
            rows={4}
            value={maintenanceDetails?.description}
          />
        </div>
        <div class="col-md-12 p-2">
          <TextInput
            step="0.01"
            type="number"
            fieldName="cost"
            label={translator("Masraf tutarı")}
            required
            value={maintenanceDetails?.cost}
          />
        </div>
        <div class="col-md-12 p-2">
          <DatePicker
            fieldName="operation_date"
            label={translator("Tarih")}
            required
            value={maintenanceDetails?.operation_date || getCurrentDay()}
          />
        </div>
        <div class="col-md-12 p-2">
          <FileUpload
            fieldName="files[]"
            multiple={true}
            label={translator("Dosyalar")}
            required={false}
            selectedFiles={maintenanceDetails?.files || []}
          />
        </div>
      </div>
    </form>
  </div>
  <div slot="modal-footer">
    <Button
      size="sm"
      onClick={null}
      formName="maintenance-form"
      colorCls={maintenanceDetails?.id ? "btn-warning" : "btn-success"}
    >
      {translator(maintenanceDetails?.id ? "Güncelle" : "Kaydet")}
    </Button>
    <Button size="sm" onClick={modalToggleWrapper} colorCls="btn-dark">
      {translator("Vazgeç")}
    </Button>
  </div>
</Modal>
